import _ from 'lodash'
import createCrudModule from 'vuex-crud'
import api from 'utils/api'

const state = {
  meta: {},
  isInviting: false
}

const actions = {
  invite({ commit }, { id }) {
    const url = `/workers/${id}/invite`;
    commit('inviteStart')
    
    return api.client.post(url)
      .then(res => {
        commit('inviteEnd')
        return Promise.resolve(res.data);
      })
      .catch(err => {
        commit('inviteEnd')
        return Promise.reject(err.response.data);
      })
  }
}

const mutations = {
  inviteStart(state) {
    state.isInviting = true;
  },

  inviteEnd(state) {
    state.isInviting = false;
  }
}

export default createCrudModule({
  client: api.client,
  resource: 'workers',
  urlRoot: '/workers',
  parseList: res => res.data,
  parseSingle: res => res.data,
  onFetchListSuccess: (state, { meta }) => {
    if (meta) state.meta = meta;
  },
  state,
  actions,
  mutations
});